<template>
  <div id="web-container" :style="{width:width,height:height}">
      <div id="web-bg">
        <img :src="Url_title" alt="" id='title-img'>
        <div id="content">
          <p id="text">暂不支持手机浏览，请用桌面浏览器打开</p>
          <p id="textEN">It is not suitable for mobile devices now, please visit by desktop's web browsers</p>
        </div>
      </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
    return {
      height: 'auto',
      width: 'auto',
      isMobile: false,
      Url_title: require('../../public/title-mobile.png')
    }
  },
  methods: {
  },
  created () {
    const that = this
    const width = document.documentElement.clientWidth
    const height = document.documentElement.clientHeight
    that.height = height + 'px'
    that.width = width + 'px'
  },
  mounted () {
    const that = this
    window.addEventListener('resize', function () {
      const h = document.documentElement.clientHeight
      const w = document.documentElement.clientWidth
      that.height = h + 'px'
      that.width = w + 'px'
    })
  }
}
</script>
<style scoped>
#web-container{
  background-color: #1F4263;;
  width:100%;
  height: 100%;
}
#web-bg{
  width:100%;
  height: 100%;
  position: relative;
  background-color: #1F4263;
}
#title-img{
  position: absolute;
  opacity:0.17;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto auto;
}
#content{
  width: 80%;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  bottom: 40%;
  margin: 0 auto;
}
#text{
  color: white;
  font-size: 20pt;
  font-weight: bolder;
  line-height: 1.3em;
  margin-bottom: 10px;
}
#textEN{
  color: white;
  font-size: 16pt;
  font-weight: bolder;
  line-height: 1.3em;
}

</style>
